import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import { MdAdd, MdRemove } from 'react-icons/md';
import { VscChevronDown } from 'react-icons/vsc';
import styled from 'styled-components';

const ToggleIconFLPlus = styled.span`
  font-size: 1.25rem;
  padding-left: 0.5rem;
`;

const ToggleIconYittyChevron = styled(VscChevronDown)`
  font-size: 24px;
  color: black;
  flex-shrink: 0;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

function BrandedToggleIcon({ open, name }) {
  const customIcon =
    config.has('public.brand.customFilterToggleIcon') &&
    config.get('public.brand.customFilterToggleIcon');

  if (customIcon) {
    return <ToggleIconYittyChevron open={open} />;
  }
  return (
    <ToggleIconFLPlus>
      {open ? (
        <MdRemove aria-hidden="true" data-autotag={`filter-${name}-collapse`} />
      ) : (
        <MdAdd aria-hidden="true" data-autotag={`filter-${name}-expand`} />
      )}
    </ToggleIconFLPlus>
  );
}

BrandedToggleIcon.propTypes = {
  name: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};
export default BrandedToggleIcon;
